import {TreeNode} from '@hconnect/common/types'
import React, {useContext, useRef, useState, useMemo} from 'react'

interface SelectedItemState {
  selectedItem: TreeNode | undefined
  setSelectedItem: React.Dispatch<React.SetStateAction<TreeNode | undefined>>
  upmPlantId: string
  setUpmPlantId: React.Dispatch<React.SetStateAction<string>>
  // When true, tree selection changes are suppressed to allow navigation blockers to fire.
  selectionGuardRef: React.MutableRefObject<boolean>
}

const SelectedItemContext = React.createContext<SelectedItemState | undefined>(undefined)

export const useSelectedItem = () => {
  const context = useContext(SelectedItemContext)
  if (!context) throw new Error('Cannot use selected item context outside of a context provider')
  return context
}

export const SelectedItemProvider = ({children}: {children: React.ReactNode}) => {
  const [selectedItem, setSelectedItem] = useState<TreeNode | undefined>(undefined)
  const [upmPlantId, setUpmPlantId] = useState<string>('')
  const selectionGuardRef = useRef(false)

  const memoizedState: SelectedItemState = useMemo(
    () => ({
      selectedItem,
      setSelectedItem,
      setUpmPlantId,
      upmPlantId,
      selectionGuardRef
    }),
    [selectedItem, setSelectedItem, setUpmPlantId, upmPlantId]
  )

  return (
    <SelectedItemContext.Provider value={memoizedState}>{children}</SelectedItemContext.Provider>
  )
}
